export const emailConsumption = "/analytics_dashboard/:app_group_id/email_credit_consumption_detail_data";
